import "./svg/coins-2.svg"

export default {
    name: "coins-2",
    viewBox: "100 100",
}
